// extracted by mini-css-extract-plugin
module.exports = {"tablePlain":"styles_tablePlain__1dyFf","pagination":"styles_pagination__SPY2d"};